import React from 'react';
import { Zap } from 'lucide-react';

// Records created live from an incident page (locations, teams/crews,
// departments, action cards) carry a description like
//   "Created from incident INC-2026-…"  or  "Created manually during incident INC-…"
// This helper extracts the incident id so the modules can flag those records
// for later admin review.
export const getIncidentOrigin = (text) => {
  const m = String(text || '').match(/created (?:from|manually during) incident\s+([A-Za-z0-9_-]+)/i);
  return m ? m[1] : null;
};

// Small amber review chip shown next to the record name in the modules.
const IncidentOriginChip = ({ description, className = '' }) => {
  const incidentId = getIncidentOrigin(description);
  if (!incidentId) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[9px] font-bold uppercase tracking-wide text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2 py-0.5 whitespace-nowrap ${className}`}
      title={`Created live during incident ${incidentId} — review recommended`}
      data-testid="incident-origin-chip"
    >
      <Zap className="h-2.5 w-2.5 fill-amber-400 text-amber-500" />
      Created during {incidentId}
    </span>
  );
};

export default IncidentOriginChip;
